"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = require("classnames");
var React = require("react");
var admin_1 = require("../../../../services/page/admin");
var Image_1 = require("../../../common/Image");
var styles = require("./index.scss");
var ProductCard = (function (_super) {
    __extends(ProductCard, _super);
    function ProductCard(props) {
        var _this = _super.call(this, props) || this;
        _this.renderPrice = function (price, originPrice) {
            var oPrice = price !== originPrice ? originPrice : "";
            return [
                React.createElement("span", { key: "price", className: styles.currentPrice }, price),
                React.createElement("span", { key: "origin-price", className: styles.originPrice }, oPrice)
            ];
        };
        _this.state = {};
        return _this;
    }
    Object.defineProperty(ProductCard.prototype, "flashTime", {
        get: function () {
            var timeStamp = Number(this.props.product.start) * 1000;
            return new Date(timeStamp).toTimeString().slice(0, 5);
        },
        enumerable: false,
        configurable: true
    });
    ProductCard.prototype.render = function () {
        var _a;
        var _b = this.props, type = _b.type, product = _b.product, flashState = _b.flashState, imageOnly = _b.imageOnly, multiTab = _b.multiTab, onClick = _b.onClick, productUrl = _b.productUrl;
        var flash = (product.extra || {}).flash;
        return (React.createElement("a", { target: "_blank", className: classnames_1.default(styles.productCard, (_a = {},
                _a[styles.soldOut] = !product.stock,
                _a[styles.imgOnly] = imageOnly,
                _a[styles.smallCard] = type === "small",
                _a)), href: productUrl, onClick: function () { return onClick && onClick(); } },
            React.createElement("div", { className: styles.image },
                flash && flash.discount && flash.discount !== "0%" && (React.createElement("div", { className: styles.discount },
                    flash.discount,
                    React.createElement("br", null),
                    "OFF")),
                React.createElement("i", { className: styles.soldOutMask }),
                React.createElement(Image_1.default, { src: product.img, className: styles.productImage, key: product.img, params: "imageView2/2/w/300", aliSize: 3 })),
            imageOnly && (React.createElement("div", { className: styles.controller },
                React.createElement("span", null,
                    React.createElement("b", null, product.stock),
                    " pcs left"),
                flashState === admin_1.TActState.OnGoing && (React.createElement("a", { className: styles.buyNow, href: productUrl, target: "_blank" }, "Buy Now")),
                flashState === admin_1.TActState.ComingSoon && (React.createElement("a", { className: styles.comingSoon, href: productUrl, target: "_blank" },
                    this.flashTime,
                    React.createElement("br", null),
                    "Coming Soon")))),
            React.createElement("div", { className: styles.description },
                React.createElement("p", null, product.name),
                React.createElement("div", { className: styles.price },
                    this.renderPrice(product.price, product.originPrice),
                    !multiTab && flashState === admin_1.TActState.ComingSoon && (React.createElement("span", { className: styles.flashTime },
                        React.createElement("img", { src: "https://i.ezbuy.sg/FolWSpjpPRssbUZKKShGIL1zqCCh", alt: "" }),
                        this.flashTime))),
                React.createElement("div", { className: styles.suffix },
                    React.createElement("span", null,
                        React.createElement("b", null, product.stock),
                        " pcs ",
                        flashState === admin_1.TActState.OnGoing && "left"),
                    flashState === admin_1.TActState.OnGoing && (React.createElement("a", { className: styles.buyNow, href: productUrl, target: "_blank" }, "Buy Now")),
                    flashState === admin_1.TActState.ComingSoon && (React.createElement("a", { className: styles.comingSoon, href: productUrl, target: "_blank" }, "Coming Soon"))))));
    };
    ProductCard.defaultProps = {
        type: "normal"
    };
    return ProductCard;
}(React.PureComponent));
exports.default = ProductCard;
